<template>
  <div class="color-alpha" @mousedown.prevent.stop="selectAlpha">
    <canvas ref="canvasAlpha" class="canvas" />
    <div :style="slideAlphaStyle" class="slide" />
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    rgba: {
      type: Object,
      default: null,
    },
    width: {
      type: Number,
      default: 15,
    },
    height: {
      type: Number,
      default: 152,
    },
  },
  data() {
    return {
      slideAlphaStyle: {},
      alphaSize: 5,
    };
  },
  watch: {
    color() {
      this.renderColor();
      this.renderSlide();
    },
    'rgba.a'() {
      this.renderSlide();
    },
  },
  mounted() {
    this.renderColor();
    this.renderSlide();
  },
  methods: {
    renderColor() {
      const canvas = this.$refs.canvasAlpha;
      const width = this.width;
      const height = this.height;
      const size = this.alphaSize;
      const canvasSquare = this.createAlphaSquare(size);

      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;

      ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
      ctx.fillRect(0, 0, width, height);

      this.createLinearGradient('l', ctx, width, height, 'rgba(255,255,255,0)', this.color);
    },
    renderSlide() {
      this.slideAlphaStyle = {
        left: this.rgba.a * this.width - 2 - 5 + 'px',
        background: this.color,
      };
    },
    selectAlpha(e) {
      const { left: hueLeft } = this.$el.getBoundingClientRect();
      const mousemove = (e) => {
        let x = e.clientX - hueLeft;

        if (x < 0) {
          x = 0;
        }
        if (x > this.width) {
          x = this.width;
        }

        const a = parseFloat((x / this.width).toFixed(2));
        this.$emit('selectAlpha', a);
      };

      mousemove(e);

      const mouseup = () => {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.color-alpha {
  position: relative;
  cursor: pointer;

  .slide {
    position: absolute;
    top: 4px;
    border: 1px solid rgb(255, 255, 255);
    box-sizing: border-box;
    transform: rotate(90deg);
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background: $bg;
    cursor: ew-resize;
  }

  .canvas {
    border-radius: 5px;
    display: inline;
    vertical-align: unset;
  }
}
</style>
